import $ from 'jquery';
import Customer from './customer.js';
import {HTTP_STATUS_OK} from '../smartpak/httpstatus.js';
import sendGAEvent from './sendgaevent.js';
import view from './customerview.js';

var customerInfo = {
    displayCustomerInfo: function(info) {
        if (info) {
            view.setCartItemCount(info.itemCount);
            view.setLoginStatus(info.isLoggedIn);
            view.setGreeting(info.firstName, info.isTaxExempt);
            view.setAccountLink(info);
            view.checkBackOrderItem(info.hasActionableClaims);
            view.setFirstName(info.formattedName);

            if (info.hasHorse) {                
                const $list = document.getElementById('ds-main-nav');

                if ($list) {
                    $list.classList.add('list-customer-has-horses');
                }
                view.setSmartPaksNavList($list);
            }

            if (info.hasACreditCardMessage) {
                view.showCreditCardMessage();
                customerInfo._yieldToolTip();
            }

            if (info.hasAContactUsMessage) {
                view.showContactUsMessage();
            }
            
            if (info.colicareEligibleHorses.length) {
                view.addColicareMessage(info.colicareEligibleHorses[0].name);
            }

            if (info.itemsRemovedFromCartJson && info.itemsRemovedFromCartJson.length) {
                import('../views/shared/showremoveditemsmessage.js').then(
                    ({default: showRemovedItemsMessage}) => {
                        showRemovedItemsMessage(info.itemsRemovedFromCartJson);
                    }
                );
            }
        }
    },
    _promise: null,
    getCustomerInfo: function(forceReload) {
        if (!this._promise || forceReload) {
            this._promise = new $.Deferred();

            $.get('/api/user/status')
                .done(this._promise.resolve)
                .fail(this._promise.reject);
        }

        return this._promise;
    },
    init: function() {
        this.loadCustomerInfo();
        this._initGaClickEvents();
    },
    _triggerSPEUserEvent: function(isSpeUser) {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'SPEUserUpdate',
                isSPEUser: isSpeUser
            });
        }
    },
    _handleSPEUser: function(isSpeUser) {
        if (isSpeUser) {
            smartPak.page.loadScript('/jsscripts/views/RefCode/RefCode.js', function() {
                if (smartPak.refCode) {
                    smartPak.refCode.init($('.siteWrapper'));
                }
            });
        }

        this._triggerSPEUserEvent(isSpeUser);

        if (smartPak.dynamicYield && !isSpeUser) {
            smartPak.dynamicYield.audienceEvent(smartPak.cdProfileCookie);
        }
    },
    loadCustomerInfo: function() {
        this.getCustomerInfo()
            .done(result => {
                if (result && result.status === HTTP_STATUS_OK) {
                    this._handleSPEUser(result.content.isSpeUser);                                    
                    this.displayCustomerInfo(new Customer(result.content, smartPak.cdProfileCookie));
                    this.setIsPrimeEligible(result.content);
                }
            })
            .fail(function(result) {
                if (window.console && window.console.log) {
                    window.console.log('Service call failed: ' + result.status + ':' + result.statusText, result);
                }
            });
    },
    setIsPrimeEligible: function(content) {
        customerInfo.isPrime = content.isPrimeEligible;
    },
    refreshCartItemCount: function() {
        customerInfo.getCustomerInfo(true).done(function(response) {
            if (response && response.status === HTTP_STATUS_OK) {
                view.setCartItemCount(response.content.itemCount);
            }
        });
    },
    _yieldToolTip: function() {
        import('../smartpak/tooltipproxy').then(({tooltipProxy}) => tooltipProxy($('.yieldAcct'), {}));
    },
    _initGaClickEvents: function() {
        $(document)
            .on('mouseover', '#customerInfoNav .infoDrop > a', function(e) {
                sendGAEvent(e.currentTarget, 'mouseover');
            })
            .on('click', '#customerInfoNav a:not(.infoDrop)', function(e) {
                sendGAEvent(e.currentTarget, 'mouseover');
            });
    }
};

export default customerInfo;
